import { evolve } from './object';
export const DEBUG = 3;
export const INFO = 2;
export const WARN = 1;
export const ERROR = 0;
const options = {
    level: ERROR,
    on: false,
    api: '',
};
const validateLevel = (level) => {
    if (typeof level === 'number') {
        return level > DEBUG ? DEBUG : level;
    }
    switch (level) {
        case 'error':
            return ERROR;
        case 'warn':
            return WARN;
        case 'debug':
            return DEBUG;
        default:
            return INFO;
    }
};
const evolveOptions = evolve({
    level: validateLevel,
});
export const init = ($options) => {
    Object.assign(options, evolveOptions($options || {}));
    const levels = ['debug', 'info', 'warn', 'error'];
    for (const level of levels) {
        if (!console.hasOwnProperty(level)) {
            // @ts-ignore
            console[level] = console.log;
        }
    }
};
export const getLevelText = () => {
    if (!options.on) {
        return 'off';
    }
    switch (options.level) {
        case ERROR:
            return 'error';
        case WARN:
            return 'warn';
        case INFO:
            return 'info';
        case DEBUG:
            return 'debug';
        default:
            return 'off';
    }
};
export default function logline(_thing, messageLevel = INFO) {
    messageLevel = validateLevel(messageLevel);
    if (!options.on || messageLevel > options.level) {
        return;
    }
    const thing = castArray(_thing);
    const prepend = `[mol-ads-cmp-${options.api}]`;
    switch (messageLevel) {
        case DEBUG:
            console.debug(`${prepend} [DEBUG] `, ...thing);
            break;
        case INFO:
            console.info(`${prepend} [INFO] `, ...thing);
            break;
        case WARN:
            console.warn(`${prepend} [WARN] `, ...thing);
            break;
        case ERROR:
            console.error(`${prepend} [ERROR] `, ...thing);
            break;
        default:
            console.log(...thing);
            break;
    }
}
const castArray = (something) => {
    if (typeof something === 'undefined') {
        return [];
    }
    else if (Array.isArray(something)) {
        return something;
    }
    else {
        return [something];
    }
};
export function log(...args) {
    const level = args.pop();
    logline(args, level);
}
